// extracted by mini-css-extract-plugin
export default {"FullOverlay":"FullOverlay_FullOverlay__Kopeu","Titlebar":"FullOverlay_Titlebar__ZdCNn","CloseButton":"FullOverlay_CloseButton__XQFah","Third":"FullOverlay_Third__Yq2r3"};